__turbopack_context__.v({
  "slider": "-EDlwG_slider",
});
